<div class="period-box">
  <button
    [disabled]="disabled"
    class="nav-btn fs-1 nav-btn-prev"
    type="button"
    (click)="onPreviousClick()"
  >
    <
  </button>

  <div class="period-text">
    <span>{{ startDateFormatted }}</span> - <span>{{ endDateFormatted }}</span>
  </div>

  <button
    [disabled]="disabled"
    class="nav-btn fs-1 nav-btn-next"
    type="button"
    (click)="onNextClick()"
    [disabled]="!canNavigateNext()"
  >
    >
  </button>
</div>
